import styled from 'styled-components';

// ############################ Styles ###########################
// tslint:disable:variable-name

const Title = styled.h1(
  ({ theme }) => `
  font-weight: ${theme.font.weight.bold};
  color: ${theme.colors.primary};
  font-size: ${theme.font.size.large};
  @media only screen and ${theme.device.laptop} {
    font-size: ${theme.font.size.huge};
  }
`
);

// tslint:enable:variable-name
// ############################ End Styles ###########################

export default Title;
